export function PrimaryButton(props){
    const {onClick, children} = props
    return <button onClick={onClick} className={'primaryButton w-10'}> {children} </button>
}